<template lang="html">
  <div class="card grid-margin">
    <label v-if='isChecked' class="form-check-label">
       <input v-model="strategy.check_bot" :checked="value" type="checkbox"  class="select-bot" :value="strategy.id" @change="$emit('input', $event.target.checked), checkStrategy()">
        <i class="input-helper"></i>
    </label>
    <div class="card-body">
      <div class="col-12">
        <router-link :to="{path: '/dashboard/market', query: { filter: badge, category:$parent.category }}" class='badge badge-primary' v-for="badge in this.badges" :key="badge">
          {{badge}}
        </router-link>
        <div class="float-right" style='font-size: 130%;' :id='"connectionCount"+strategy.id'>
          <span><i class="fas fa-link"></i><b>{{strategy.connections}}</b></span>
        </div>
        <div v-if='strategy.for_new_users' class="float-right" :id='"recommand"+strategy.id' style="margin-right:20px">
          <svg width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="50%" y1="-115.625%" x2="50%" y2="120.282%" id="b"><stop stop-color="#FC0" offset="0%"/><stop stop-color="#F77D0E" offset="100%"/></linearGradient><path id="a" d="M0 3.9L2.717 16.59 11.984 24l8.946-7.738L24 3.899 12 0z"/></defs><g fill="none" fill-rule="evenodd"><use fill="url(#b)" xlink:href="#a"/><path d="M12.092 13.66l-3.458 1.926.66-4.08-2.797-2.89 3.866-.595 1.729-3.712L13.82 8.02l3.866.596-2.798 2.89.66 4.08z" fill="#FFF"/></g></svg>
        </div>
        <div v-if="strategySubscriptions&&(strategySubscriptions.autotrade || strategySubscriptions.percent_usdt)" :id="'trading-icon-'+strategySubscriptions.id" class="float-right" style="margin-right:10px; width:35px;margin-top: -4px;">
          <img  style="width:30px; cursor:pointer;" src="/static/images/trading.png?r=1" alt="trading">
        </div>
        <b-tooltip v-if='strategy.for_new_users' :target='"recommand"+strategy.id' triggers="hover">
          {{lang=="ru"?"Наша рекомендация для новых пользователей":"Our recommendation for new users"}}
        </b-tooltip>
        <b-tooltip v-if="strategySubscriptions&&(strategySubscriptions.autotrade || strategySubscriptions.percent_usdt)" :target="'trading-icon-'+strategySubscriptions.id" triggers="hover">
          {{lang=="ru"?"Используется":"In work"}}
        </b-tooltip>
        <b-tooltip :target='"connectionCount"+strategy.id' triggers="hover">
          {{lang=="ru"?"Рейтинг по количеству подключений":"Rating by number of connections"}}
        </b-tooltip>
      </div>
      <br> <h2 class="card-headed">{{strategy.title}}</h2>
      <div class="float-left">
        <div style='display: inline-block;'>
          {{lang=="ru"?"Прибыль с актива":"Profit with asset "}} {{strategy.preferred_pair}} <br>{{lang=="ru"?"и рекомендуемые параметры за ":"and advised settings for "}} {{ backtestPeriod }}:
        </div>
        <div style='display: inline-block;'>
          <span style='font-size: 200%'>{{strategy.profitability.toFixed(2)}}%</span>
        </div>
      </div>
      <div class="float-right">
        <!-- <span class="price-label">{{strategy.price}}$ <span class="period">/ {{lang=="ru"?"Месяц":"month"}}</span></span> -->
        <!-- <span class="price-label">100$ <span class="period">/ year</span></span> -->
          <router-link v-if="strategySubscriptions" class="btn btn-primary mt-2 mt-sm-0 d-block d-sm-inline-block open-button" :to="strategySubscriptions.status==1?'/subscription/edit/' + strategySubscriptions.id:strategySubscriptions.status==2?'/subscription/edit/' + strategySubscriptions.id:'/backtest/' + strategy.id+'?expire=true'">
            {{strategy_text}}
          </router-link>
          <router-link v-else :to="'/backtest/' + strategy.id" class="btn btn-primary mt-2 mt-sm-0 d-block d-sm-inline-block">{{lang=="ru"?"Показать":"Review"}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      lang: 'en',
      strategy_text: 'Open'
    }
  },
  mounted () {
    this.lang = this.$cookie.get('lang')
    if (this.lang === 'ru') {
      this.strategy_text = 'Открыть'
    }
  },
  methods:{
      checkStrategy(){
        this.$root.$emit("checkedbots");
      },
  },
  computed: {
    badges () {
      return this.strategy.tags.split(',')
    },
    backtestPeriod () {
      if (this.strategy.preferred_timeframe === '240') { return this.lang=='ru'?'всё время':'all time' }
      else if (this.strategy.preferred_timeframe === '60') { return this.lang=='ru'?'последние 6 месяцев': 'past 6 months' }
      else if (this.strategy.preferred_timeframe === '15') { return this.lang=='ru'?'последние 3 месяцев': 'past 3 months' }
      else { return this.lang == 'ru'?'всё время':'all time' }
    },
    strategySubscriptions () {
      var subscription = this.$parent.$parent.subscriptions.filter(subscription => subscription.strategy_id == this.strategy.id)
      return subscription[0]
    }
  },
  props: ['strategy', 'connections', 'big_subscription', 'isChecked', 'value', 'checkbots']
}
</script>

<style lang="css" scoped>
a.badge {
  margin-right: 10px;
}
.select-bot{
    position: absolute;
    right: 5px;
    top: 5px;
    width: 20px;
    height: 20px;
    z-index: 1;
    cursor: pointer;
    opacity: 0;
}
.form-check-label {
    min-height: 18px;
    display: block;
    margin-left: 1.75rem;
    font-size: .75rem;
    line-height: 1.5;
}
input[type=checkbox], input[type=radio] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0;
}
 label input[type=checkbox]:checked+.input-helper:before,label input[type=radio]:checked+.input-helper:before {
    background: #464dee;
}
.form-check-label input[type=checkbox]:checked+.input-helper:before {
    background: #464dee;
    border-width: 0;
}
label input[type=checkbox]+.input-helper:before,  label input[type=radio]+.input-helper:before {
    border-color: #464dee;
}
 input[type=checkbox]+.input-helper:before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 2px;
    border: 2px solid #464dee;
    -webkit-transition: all;
    transition: all;
    transition-duration: 0s;
    -webkit-transition-duration: .25s;
    transition-duration: .25s;
}
 input[type=checkbox]+.input-helper:after,  input[type=checkbox]+.input-helper:before {
    position: absolute;
    top: 5px;
    right: 5px;
}

 input[type=checkbox]+.input-helper:after {
    -webkit-transition: all;
    transition: all;
    transition-duration: 0s;
    -webkit-transition-duration: .25s;
    transition-duration: .25s;
    opacity: 0;
    filter: alpha(opacity=0);
    -webkit-transform: scale(0);
    transform: scale(0);
    content: "\2713";
    font-size: .9375rem;
    font-weight: 700;
    color: #fff;
}
 input[type=checkbox]:checked+.input-helper:after {
    width: 20px;
    opacity: 1;
    line-height: 20px;
    filter: alpha(opacity=100);
    -webkit-transform: scale(1);
    transform: scale(1);
}
.open-button{
  background: black !important;
  border: none !important;
  border: 1px solid #fff !important
}
.open-button:hover{
  background: #323232 !important;
}
.open-button{
    -webkit-box-shadow: none !important;
     box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/StrategyCard.vue